








































































import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import Photoswipe from 'vue-pswipe';
// @ts-ignore
import { Carousel, Slide } from 'vue-carousel';

Vue.use(Photoswipe);

// --- Fix TS2307: utiliser require() plutôt qu'un import d'image ---
// Si tes types TS n'incluent pas Node, on déclare require pour éviter l'erreur.
declare const require: any;
// Webpack résout l'asset à la build et retourne une URL string
const PLACEHOLDER_URL: string = require('../../assets/images/special/1.png');

interface PhotoswipeInstance {
  destroy: Function;
}

@Component({
  components: {
    Carousel,
    Slide,
  },
})
export default class CarouselPrescriber extends Vue {
  @Prop({ default: () => [] }) images!: string[];
  @Prop({ default: 500 }) height!: number;
  @Prop({ default: 5 }) perPage!: number;



  @Prop({ default: 0 }) programId!: number;



  page: number = 0;
  paginationPage: number = 0;
  pswp: PhotoswipeInstance | null = null;

  // marque les index qui ont échoué au chargement
  failed: boolean[] = [];

  options = {
    showHideOpacity: true,
    getThumbBoundsFn: false,
  };

  // URL du placeholder (via require)
      get placeholder(): string {
        const imageNumber = (this.programId % 30) + 1;
        return require(`../../assets/images/special/${imageNumber}.png`);
    }

    getRandomPlaceholderImage(programId: number): string {
      const imageNumber = (programId % 30) + 1;
      return require(`../../assets/images/special/${imageNumber}.png`);
    }


  get hasImages() {
    return Array.isArray(this.images) && this.images.length > 0;
  }

  get cleanImages(): string[] {
    return (this.images || []).filter(Boolean);
  }

  beforeOpen(_: unknown, next: Function) {
    const $carousel: any = this.$refs.carousel;
    const dragging = $carousel && $carousel._data && $carousel._data.dragMomentum !== 0;
    next(!dragging);
  }

  onClick(index: number) {
    const $carouselPagination: any = this.$refs.carouselPagination;
    const dragging =
      $carouselPagination &&
      $carouselPagination._data &&
      $carouselPagination._data.dragMomentum !== 0;

    if (!dragging) {
      this.page = index;
    }
  }

  onOpened(pswp: PhotoswipeInstance) {
    this.pswp = pswp;
  }

  destroyed() {
    if (this.pswp) {
      this.pswp.destroy();
    }
  }

  @Watch('page')
  onPage() {
    this.paginationPage = Math.floor(this.page / this.perPage);
  }

  @Watch('images', { immediate: true })
  onImagesChanged(newVal: string[]) {
    this.failed = Array((newVal || []).length).fill(false);
  }

  onImgError(index: number, evt: Event) {
    if (!this.failed[index]) {
      this.$set(this.failed, index, true);
      const el = evt.target as HTMLImageElement;
      if (el && el.src !== this.placeholder) {
        el.src = this.placeholder; // swap vers le placeholder
      }
    }
  }
}
